// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [];

module.exports = angular
  .module('bench.ui.radio', deps)

  .directive('blRadio', $parse => ({
    restrict: 'A',
    scope: false,
    link(scope, elem, attrs) {
      const obj = $parse(attrs.blRadio)(scope);
      const ownVal = attrs.blRadioValue;

      return elem.on('click', () =>
        scope.$apply(() => angular.forEach(obj, (state, val) => (obj[val] = val === ownVal))),
      );
    },
  }));
